const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV

const API_BASE_URL_LIST = {
  "development":  "https://pzj5ji42gb.execute-api.ap-northeast-1.amazonaws.com/api",
  "staging":     "https://xexcoshs82.execute-api.ap-northeast-1.amazonaws.com/api",
  "production": "https://ny43l5e4pe.execute-api.ap-northeast-1.amazonaws.com/api"
}
const API_BASE_URL = API_BASE_URL_LIST[env_key]

const API_ID = "MX1"
const SITE_TITLE = "Tabi-CONNECT"
const AVAILABLE_LANGUAGES = ['ja', 'en', 'zh-TW']
const ENABLED_DOCOMO_MOBAKU = true
// このエリアを検索のボタン表示
const ENABLED_MAP_SEARCH_PLACE = true
// 名称検索時に表示するPOIの最大数
const MAX_SEARCH_PLACE = 20
// おすすめスポットの最大数
const MAX_RECOMMEND_PLACE = 5
// デマンド交通予約一覧の最大表示数
const MAX_RESERVATIONS_COUNT = 5

const JREAST_APP_SCHEMA = "https://jreastapp.page.link"
const JREAST_PC_SITE = "https://play.google.com/store/apps/details?id=jp.co.jreast&hl=ja"
const MIXWAY_URL = "https://mixway.ekispert.net"

// 中心となる駅(東京駅)
const DEFAULT_STATION_LOCATION = {
  latitude: 35.681236,
  longitude: 139.767125
}

const DEFAULT_DEPARTURE_STATION = "仙台"
const DEFAULT_ARRIVAL_STATION = "仙台"
const DEFAULT_DEPARTURE_STATION_CODE = "21044"
const DEFAULT_ARRIVAL_STATION_CODE = "21044"

const LINK_BASE_URL_LIST = {
  "development": "https://stg.mx1.maas-portal.com",
  "staging": "https://stg.mx1.maas-portal.com",
  "production": "https://maas-portal.com"
}
const LINK_BASE_URL = LINK_BASE_URL_LIST[env_key]

const DEMAND_LINK_URL_LIST = {
  "development": "https://tour.jre-maas.com/mx1-demand-stg/#/ja/",
  "staging": "https://tour.jre-maas.com/mx1-demand-stg/#/ja/",
  "production": "https://tour.jre-maas.com/mx1-demand/#/ja/"
}
const DEMAND_LINK_URL = DEMAND_LINK_URL_LIST[env_key]

const DEFAULT_AREA_ID = "Tabi-CONNECT"
const MX1_ORAGA_LOGO_LIST = {
  "Tabi-CONNECT": "logo_mx.png",
  "tohoku": "tohoku-maas-sendai.png",
  "kaiyukaruizawa": "karuizawa_MaaS_logo_D.jpg",
  "tabisuru-kitashinano": "tabisuru-kitashinano.png",
  "hitachinokunikiko": "MIto_MaaS_logo_A.png",
  "izunavi": "izu_logo.jpg",
  "ekitomaticket": "ekitomaticket.jpg",
  "vin-de-yamanashi": "basic_2_without_copy.jpg",
  "nasu-ways": "nasu-ways.jpg",
  "eeeechoshi": "eeeechoshi.jpg",
  "marugotowakashio-maas": "marugotowakashio.png",
  "takkomaas": "takkomaas_logo.png",
}

const REAL_TIME_SEARCH_WEB_LIST = {
  "development": "https://transit-stg.jre-maas.com/",
  "staging": "https://transit-stg.jre-maas.com/",
  "production": "https://transit.jre-maas.com/"
}
const REAL_TIME_SEARCH_WEB = REAL_TIME_SEARCH_WEB_LIST[env_key]

const SENDAI_STA_POLE = [
  {
    no: "4",
    poi_id: "2104404"
  },
  {
    no: "5",
    poi_id: "2104405"
  },
  {
    no: "6",
    poi_id: "2104406"
  },
  {
    no: "9",
    poi_id: "2104409"
  },
  {
    no: "10",
    poi_id: "2104410"
  },
  {
    no: "11",
    poi_id: "2104411"
  },
  {
    no: "13",
    poi_id: "2104413"
  },
  {
    no: "14",
    poi_id: "2104414"
  },
  {
    no: "15",
    poi_id: "2104415"
  },
  {
    no: "16",
    poi_id: "2104416"
  },
  {
    no: "17",
    poi_id: "2104417"
  },
  {
    no: "18",
    poi_id: "2104418"
  },
  {
    no: "19",
    poi_id: "2104419"
  },
  {
    no: "27",
    poi_id: "2104427"
  },
  {
    no: "28",
    poi_id: "2104428"
  },
  {
    no: "50",
    poi_id: "2104450"
  },
  {
    no: "51",
    poi_id: "2104451"
  },
  {
    no: "60",
    poi_id: "2104460"
  },
  {
    no: "98",
    poi_id: "2104498"
  }
]

const BUS_LOCATION_API_URL = "https://l102b1vo5l.execute-api.ap-northeast-1.amazonaws.com/stg/v1/"
const BUS_LOCATION_API_KEY = "5mwdWojcjm3pXgOZadGiX5ORXujM2yDE5Xge1bS7"
const BUS_LOCATION_TRIP_COUNT = 3

export default {
  API_ID: API_ID,
  SITE_TITLE: SITE_TITLE,
  AVAILABLE_LANGUAGES: AVAILABLE_LANGUAGES,
  ENABLED_DOCOMO_MOBAKU: ENABLED_DOCOMO_MOBAKU,
  ENABLED_MAP_SEARCH_PLACE: ENABLED_MAP_SEARCH_PLACE,
  MAX_SEARCH_PLACE: MAX_SEARCH_PLACE,
  MAX_RECOMMEND_PLACE: MAX_RECOMMEND_PLACE,
  MAX_RESERVATIONS_COUNT: MAX_RESERVATIONS_COUNT,
  DEFAULT_STATION_LOCATION: DEFAULT_STATION_LOCATION,
  DEFAULT_DEPARTURE_STATION: DEFAULT_DEPARTURE_STATION,
  DEFAULT_ARRIVAL_STATION: DEFAULT_ARRIVAL_STATION,
  DEFAULT_DEPARTURE_STATION_CODE: DEFAULT_DEPARTURE_STATION_CODE,
  DEFAULT_ARRIVAL_STATION_CODE: DEFAULT_ARRIVAL_STATION_CODE,
  JREAST_APP_SCHEMA: JREAST_APP_SCHEMA,
  JREAST_PC_SITE: JREAST_PC_SITE,
  MIXWAY_URL: MIXWAY_URL,
  LINK_BASE_URL: LINK_BASE_URL,
  DEMAND_LINK_URL: DEMAND_LINK_URL,
  API_BASE_URL: API_BASE_URL,
  SENDAI_STA_POLE: SENDAI_STA_POLE,
  BUS_LOCATION_API_URL: BUS_LOCATION_API_URL,
  BUS_LOCATION_API_KEY: BUS_LOCATION_API_KEY,
  BUS_LOCATION_TRIP_COUNT: BUS_LOCATION_TRIP_COUNT,
  DEFAULT_AREA_ID: DEFAULT_AREA_ID,
  MX1_ORAGA_LOGO_LIST: MX1_ORAGA_LOGO_LIST,
  REAL_TIME_SEARCH_WEB: REAL_TIME_SEARCH_WEB
}